// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__25djG","title":"BackImages_title__1Ydhm","images":"BackImages_images__3IG6A"};